import {ActionTree, GetterTree, MutationTree} from 'vuex';
import Result from '@/components/Results/Result';
import ResultArray from '@/components/Results/ResultArray';

interface State {
    items: ResultArray;
}

const state: State = {
    items: new ResultArray(),
};

const getters: GetterTree<State, any> = {
    results: (state) => state.items,
    lastResult: (state) => state.items.last,
};

const mutations: MutationTree<State> = {
    addResult(state, item: Result) {
        state.items.add(item);
    },
    fillResults(state, items: Result[]) {
        state.items.fromJSON(items);
    },

    resetResults(state) {
        state.items.clear();
    },
};

const actions: ActionTree<State, any> = {
    writeResults({state, commit, dispatch}) {
        dispatch('clearResultsStorage');
        localStorage.setItem('results', JSON.stringify(state.items.all));
        commit('resetResults');
        dispatch('getResults');
    },

    clearResultsStorage() {
        localStorage.removeItem('results');
    },

    clearAllResults({commit}) {
        commit('resetResults');
        localStorage.removeItem('results');
    },

    getResults({state, commit}) {
        const json: string | null = localStorage.getItem('results');

        if (json) {
            const resultObj: any = JSON.parse(json);
            commit('fillResults', resultObj);
        }
    },
};

export const results = {
    state,
    getters,
    mutations,
    actions,
};

